import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  && .MuiSvgIcon-root {
    ${({ width }: { width?: number }) =>
      width &&
      css`
        width: ${width}px;
      `}

    ${({ height }: { height?: number }) =>
      height &&
      css`
        height: ${height}px;
      `}
  }
`;
